import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHero, useTableSort, SortableTH } from "@/components/common";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";

export default function AuditTrail() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/audit", { params: { limit: 500 } }).then((r) => setRows(r.data)).catch(() => {}); }, []);

  const fmt = (v) => v == null ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v);
  const filtered = rows.filter((r) => `${r.entity_type} ${r.action} ${r.user_name} ${r.reason || ""}`.toLowerCase().includes(q.toLowerCase()));
  const { sorted, sort, toggle } = useTableSort(filtered, {
    when: (r) => r.timestamp, entity: (r) => r.entity_type, action: (r) => r.action,
    user: (r) => r.user_name, reason: (r) => r.reason || "",
  }, { key: "when", dir: "desc" });

  return (
    <div className="space-y-5">
      <PageHero title="Audit Trail" subtitle="Complete change history — records are never deleted." eyebrow="Governance" pageKey="audit" />
      <Input placeholder="Search audit log…" value={q} onChange={(e) => setQ(e.target.value)} className="max-w-sm bg-white" data-testid="audit-search" aria-label="Search audit log" />
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-x-auto cass-scroll">
        <Table>
          <TableHeader><TableRow className="bg-slate-50">
            <SortableTH label="When" sortId="when" sort={sort} onSort={toggle} />
            <SortableTH label="Entity" sortId="entity" sort={sort} onSort={toggle} />
            <SortableTH label="Action" sortId="action" sort={sort} onSort={toggle} />
            <SortableTH label="User" sortId="user" sort={sort} onSort={toggle} />
            <TableHead className="text-xs uppercase text-slate-600">Change</TableHead>
            <SortableTH label="Reason" sortId="reason" sort={sort} onSort={toggle} />
          </TableRow></TableHeader>
          <TableBody>
            {sorted.map((r) => (
              <TableRow key={r.id} data-testid={`audit-row-${r.id}`}>
                <TableCell className="text-xs whitespace-nowrap">{new Date(r.timestamp).toLocaleString("en-GB")}</TableCell>
                <TableCell className="capitalize text-sm">{r.entity_type?.replace("_", " ")}</TableCell>
                <TableCell><span className="text-xs px-2 py-0.5 rounded bg-[#EFF8FF] text-[#2EA3FD] capitalize">{r.action}</span></TableCell>
                <TableCell className="text-sm">{r.user_name}</TableCell>
                <TableCell className="text-xs text-slate-500 max-w-xs truncate">{r.new_value ? fmt(r.new_value) : "—"}</TableCell>
                <TableCell className="text-xs text-slate-500">{r.reason || "—"}</TableCell>
              </TableRow>
            ))}
            {sorted.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-400 py-8">No audit records</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
